import React from "react";
import ReactDOM from "react-dom/client";
import Rotas from "./rotas";
import "./style/global.css";

import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<ThemeProvider theme={theme}>
		<Rotas />
	</ThemeProvider>,
);

// import React from "react";
// import ReactDOM from "react-dom/client";
// import Rotas from "./rotas";
// import "./style/global.css";

// // ReactDOM.render(
// // 	<Rotas />,

// // 	document.getElementById("root")
// // );

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<Rotas />);
